<template>
    <a-modal
            title="新增消费券"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @ok="handleSubmit"
            @cancel="handleCancel"
            okText="确定"
            cancelText="取消"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="面值"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="value" placeholder="输入消费券面值（单位：元）" v-decorator="['value', {rules: [{type: 'integer', required: true, min: 1, message: `消费券面值需为整数且至少为1元`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="描述"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="description" placeholder="输入消费券描述（如使用范围）" v-decorator="['description', {rules: [{max: 40, message: '最多只能输入40个字符'}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="上传logo"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-upload
                            action="/vendor-api/couponManage/uploadImg"
                            list-type="picture"
                            :withCredentials="true"
                            @change="handleFileChange"
                    >
                        <a-button> <a-icon type="upload" /> upload </a-button>
                    </a-upload>
                    <span>（多次上传只保留最近一次）</span>
                </a-form-item>
                <a-form-item
                        label="所需积分"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="point" placeholder="输入兑换所需积分" v-decorator="['point', {rules: [{type: 'integer', required: true, min: 1, message: `积分需为整数且至少为1`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="发行数量"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="totalAmount" placeholder="输入需要发行的数量" v-decorator="['totalAmount', {rules: [{type: 'integer', required: true, min: 1, message: `发行数量需为整数且至少为1`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
                visible: false,
                confirmLoading: false,

                form: this.$form.createForm(this),
                formData: {},


                // 上传文件相关
                upload: {
                    file: "",
                    // 是否已上传
                    // haveUpload: false,
                }
            }
        },
        props: {
            formType: ''
        },
        methods: {
            showForm(formData) {
                this.form.resetFields()
                this.visible = true
                this.formData = formData
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    if (!errors) {
                        if(this.upload.file === "") {
                            this.$message.error("需要上传logo")
                            this.confirmLoading = false
                            return
                        }
                        values.imageUrl = this.upload.file
                        this.$emit('create', values)
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            },

            // 文件上传相关
            /*beforeUpload(file, fileList) {
                if(this.upload.haveUpload) {
                    this.$message.error("只能上传一个文件");
                    return false
                }
                this.upload.haveUpload = true
                return true
            },*/
            handleFileChange({file, fileList, event}) {
                fileList = fileList.slice(-1)   // 只保留一个文件
                if("error" === file.status || ("done" === file.status && !file.response.success ) )
                    this.$message.error("上传失败")
                else if("done" === file.status && file.response.success) {
                    this.$message.success("上传成功！")
                    this.upload.file= file.response.message
                }
            },
        },
    }
</script>

<style scoped>
    /* tile uploaded pictures */
    .upload-list-inline >>> .ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
    }
    .upload-list-inline >>> .ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }
    .upload-list-inline >>> .ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }
</style>
